// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w2k1","colBig":"styles_colBig__3IS_Z","colSmall":"styles_colSmall__33rap"};